import React, { useEffect, useState } from 'react';
import { getAllCountriesOnLanguageID } from '../../data-sources/api';
import { Form } from 'react-bootstrap';

/**
 * CountrySelect component that fetches and displays a list of countries based on the provided language ID.
 * 
 * @param {number} languageID - The ID of the language to fetch countries in.
 * @returns {JSX.Element} A form element containing a list of countries.
 */
export function CountrySelect({ languageID }) {
    const [countries, setCountries] = useState();

    /**
     * Fetches a list of countries based on the language ID
     */
    const fetchCountries = async () => {
        try {
            const response = await getAllCountriesOnLanguageID(languageID);
            setCountries(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    /**
     * Fetch countries when the language ID changes
     */
    useEffect(() => {
        fetchCountries();
    }, [languageID]);

    return (
        <Form.Select>
            {countries?.length > 0 && countries.map((country) => {
                return (
                    <>
                        <option value={country.id} key={country.id}>{country.countryName}</option>

                        { // Insert line break after the Iraq option
                            country.id === 4 && <option disabled value="-----------">-----------</option>}
                    </>
                );
            })}
        </Form.Select>
    );
}